<template>
	<v-container id="overviews" fluid>
		<!-- >>> The Data Table -->
		<v-data-table
			v-model="selected"
			style="margin-bottom: 0px; margin-top: 0px;overflow-x:auto !important;height:94.5vh"
			:headers="headers"
			:items="get_Airports_Filtered"
			:disable-pagination="true"
			:hide-default-footer="true"
			sort-by="airportName"
			:single-expand="singleExpand"
			:expanded.sync="expanded"
			show-expand
			:single-select="true"
			class="elevation-1 data-table-custom-colors">
			<!-- @contextmenu:row="(event, resourceItem) => onContextMenu_DataTableRow(event, resourceItem.item)"> -->

			<!-- >>> OpeningHours:Column -->
			<template v-slot:[`item.openingHoursFrom`]="{ item }">
				<span style="margin-left: 15px;">
					<p style="margin:0">{{ (item.openingHoursFrom && item.openingHoursTo) && `${item.openingHoursFrom} - ${item.openingHoursTo}` }}</p>
				</span>
			</template>
			<!-- <<< OpeningHours:Column -->
			<template v-slot:[`item.coordinated`]="{ item }">
				<v-chip v-if="item.coordinated === true" style="width:80px;justify-content:center" small outlined color="#4caf50">
					required
				</v-chip>
				<v-chip v-if="item.coordinated === false" style="width:80px;justify-content:center" small outlined color="#ab3b7a">
					not required
				</v-chip>
			</template>

			<!-- >>> Action:Column -->
			<!-- solved in vue3: https://stackoverflow.com/questions/61344980/v-slot-directive-doesnt-support-any-modifier -->
			<template v-slot:[`item.actions`]="{ item }">
				<span v-if="!get_Shared_isUserAllowedToUse('READONLY')" style="margin-left: 15px;">
					<v-icon small class="mr-2" :class="get_ClassForEditedRow(item)" @click="onClick_EditTableItem(item)">
						mdi-pencil
					</v-icon>
					<!-- <v-icon small @click="onClick_DeleteBlocktime(item)">
						mdi-delete
					</v-icon> -->
				</span>
			</template>
			<!-- <<< Action:Column -->

			<!-- >>> Expanded:Column -->
			<template v-slot:expanded-item="{ headers, item }">
				<td :colspan="headers.length">
					<div style="margin-left: 0px; margin-top: 24px; margin-bottom: 24px;display:flex;justify-content:space-around">
						<div style=";margin-right:34px;">
							<p>Airport Contacts</p>
							<v-data-table
								v-model="selected"
								style="margin-bottom: 0px; margin-top: 0px;width: 50vh;"
								:headers="headersAirportContacts"
								:items="item.airportContacts"
								:disable-pagination="true"
								:hide-default-footer="true"
								sort-by="name"
								class="elevation-1 data-table-custom-colors" />
						</div>
						<div>
							<p>Slot Contacts</p>
							<v-data-table
								v-model="selected"
								style="margin-bottom: 0px; margin-top: 0px;width: 50vh;"
								:headers="headersSlotContacts"
								:items="item.slotContacts"
								:disable-pagination="true"
								:hide-default-footer="true"
								sort-by="name"
								class="elevation-1 data-table-custom-colors" />
						</div>
					</div>
				</td>
			</template>
			<!-- <<< Expanded:Column -->
</v-data-table>
		<!-- <<< The Data Table -->



		<!-- >>> Dialog: 'Confirm Delete'  -->
		<v-dialog v-model="showConfirmDeleteDialog" max-width="500px">
			<v-card class="pa-4">
				<v-card-title>Are you sure you want to delete this item?</v-card-title>
					<v-card-actions class="mt-8">
						<v-spacer />
						<v-btn style="width:120px" depressed outlined color="#ab3b7a" @click="onClick_CloseDelete">
						Cancel
						</v-btn>
						<v-btn style="width:120px" depressed color="primary" @click="onClick_DeleteItemConfirm">
							OK
							</v-btn>
						<v-spacer />
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- <<< Dialog: 'Confirm Delete'  -->



		<!-- >>> Floating 'Add' Button -->
        <v-fab-transition>
            <v-btn fab fixed color="primary" bottom right style="margin-bottom: 50px; margin-right: 50px;" :disabled="get_Shared_isUserAllowedToUse('READONLY')" @click="onClick_FloatingButton()">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-fab-transition>
        <!-- <<< Floating 'Add' Button -->



		<!-- >>> Sdr-Component, BottomSheet -->
		<sdr-airports-bottom-sheet
			v-model="showSheet"
            :editorMode="editorMode"
			:airportsPrefillObject="airportsPrefillObject" />
		<!-- <<< Sdr-Component, BottomSheet -->
	</v-container>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex';
	import BottomSheet from './components/core/BottomSheet';


    export default {
        name: 'Blocktimes',


		/* >>> *************************************************************** / /* Components */
		components: {

			'sdr-airports-bottom-sheet': BottomSheet

		}, // eo components{}
		/* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Data */
		data: function() {

			return {
				// >>> Data Table Header ------------------
				headers: [
					{ text: '', value: 'data-table-select', class: 'sticky-header grey lighten-3' },
					{ text: 'Airport Name', value: 'airportName', class: 'sticky-header grey lighten-3' },
					{ text: 'IATA Code', value: 'iataCode', class: 'sticky-header grey lighten-3' },
					{ text: 'ICAO Code', value: 'icaoCode', class: 'sticky-header grey lighten-3' },
					{ text: 'Opening Hours', value: 'openingHoursFrom', class: 'sticky-header grey lighten-3' },
					{ text: 'Slot Required', value: 'coordinated', class: 'sticky-header grey lighten-3' },
					{ text: 'Level of Coordination', value: 'coordinationLevel', class: 'sticky-header grey lighten-3' },
					{ text: 'Actions', value: 'actions', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: '', value: 'data-table-expand', class: 'sticky-header grey lighten-3' }
					// currently not needed - maybe later
					// { text: '', value: 'data-table-expand', class: 'sticky-header grey lighten-3' },
				],
				headersAirportContacts: [
					{ text: 'Name', value: 'name', class: 'sticky-header grey lighten-3' },
					{ text: 'Role', value: 'role', class: 'sticky-header grey lighten-3' },
					{ text: 'Email', value: 'email', class: 'sticky-header grey lighten-3' }
					// currently not needed - maybe later
					// { text: '', value: 'data-table-expand', class: 'sticky-header grey lighten-3' },
				],
				headersSlotContacts: [
					{ text: 'Name', value: 'name', class: 'sticky-header grey lighten-3' },
					{ text: 'Email', value: 'email', class: 'sticky-header grey lighten-3' }
					// currently not needed - maybe later
					// { text: '', value: 'data-table-expand', class: 'sticky-header grey lighten-3' },
				],
				// >>> ------------------------------------
				expanded: [],
				singleExpand: true,
                // >>> ------------------------------------ Tables Checkboxes
                singleSelect: false,
                selected: [],
				// >>> ------------------------------------ Bottom Sheet
                showSheet: false,
                editorMode: null, // 'update, create'
				airportsPrefillObject: null,
				// >>> ------------------------------------ Dialog
				showConfirmDeleteDialog: false,
				resourceIdToDelete: null
			};

		}, // eo function data()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_Airports_Filtered',
				'get_Shared_isUserAllowedToUse'
			])

		}, // eo computed{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

			const me = this;


			me.$toc('>>> views/flights/airports/Home.vue >>> created');
			this.actn_call_getAirports();

		}, // eo function created()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
		methods: {

			...mapActions([
                'actn_call_getAirports',
				'actn_call_deleteAirport'
			]),


			/******************************************************************* 'Listeners -  Common'
            * Listeners:
            *******************************************************************/
			/*******************************************************************
			* onClick_FloatingButton()
			*
			* Desc:
			* Note:
			*
			*/
			onClick_FloatingButton: function() {

				const me = this;


				me.$toc('>>> views/flights/airports/Home.vue >>> onClick_FloatingButton');
				me.airportsPrefillObject = null;
                me.editorMode = 'create';
                me.showSheet = true;

			}, // eo function onClick_FloatingButton()


			/*******************************************************************
			* onClick_EditTableItem()
			*
			* Desc: Event: dbclick:row => Sets Resource Item. Set Mode 'update'.
			* Note: Opens Bottom Sheet too.
			*
			*/
			onClick_EditTableItem: function(resourceItem) {

				const me = this;


				me.$toc('>>> views/flights/airports/Home.vue >>> onClick_EditTableItem');
				me.airportsPrefillObject = resourceItem; // fill up
				me.editorMode = 'update'; // set 'mode' & 'value'
				me.showSheet = true;

			}, // eo function onClick_EditTableItem()


            /******************************************************************* 'Listeners -  Delete'
            * Listeners: Delete Item
            *******************************************************************/
            /*******************************************************************
            * onClick_DeleteBlocktime()
            *
            * Desc: Clicked 'delete' in Action Column.
            * Note: Show Dialog. Remebmer 'resourceIdToDelete'.
            *
            */
            onClick_DeleteBlocktime: function(item) {

				const me = this;


				me.$toc('>>> views/flights/airports/Home.vue >>> onClick_DeleteBlocktime');
				this.resourceIdToDelete = item.id; // save
				this.showConfirmDeleteDialog = true;

            }, // eo function onClick_DeleteBlocktime()


            /*******************************************************************
            * onClick_DeleteItemConfirm()
            *
            * Desc: Clicked 'OK' in 'Delete Confirm' Dialog.
            * Note:
            *
            */
			onClick_DeleteItemConfirm: function() {

				const me = this;


				me.$toc('>>> views/flights/airports/Home.vue >>> onClick_DeleteItemConfirm');
				this.actn_call_deleteBlocktime(this.resourceIdToDelete);
				this.onClick_CloseDelete();

			}, // eo function onClick_DeleteItemConfirm()


            /*******************************************************************
            * onClick_CloseDelete()
            *
            * Desc: Close 'confirm Delete' Dialog.
            * Note: Close Dialog. Reset 'resourceIdToDelete'.
            *
            */
			onClick_CloseDelete: function() {

                const me = this;


				me.$toc('>>> views/flights/airports/Home.vue >>> onClick_CloseDelete');
				this.resourceIdToDelete = null; // reset
				this.showConfirmDeleteDialog = false;

			}, // eo function onClick_CloseDelete()




			/*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_ClassForEditedRow()
            *
            * Desc: Returns selected Class if Row was edited (prop: 'wasEdited')
            * Note:
            *
            */
			get_ClassForEditedRow: function(item) {

                const me = this;


				me.$toc('>>> views/flights/airports/Home.vue >>> get_ClassForEditedRow');
				return item.wasEdited === true ? 'rowWasEdited' : '';

			} // eo function get_ClassForEditedRow()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>


<style scoped>
	.v-data-table /deep/ .sticky-header {
		position: sticky;
		top: 0px;
		z-index: 1;
	}

	.v-data-table /deep/ .v-data-table__wrapper {
		margin-top: 0px;
		overflow: unset;
	}

	.v-data-table /deep/ tr:nth-child(2n) {
		background-color: #FAFAFA;
	}

	.v-chip__content {
		font-size: 12px;
	}

	.rowWasEdited {
		/* border-left: 4px solid #AB3B7C;
		padding-left: 4px; */
		/* background-color: #AB3B7C; */
		border: 2px solid #AB3B7C;
		padding: 2px;

	}
</style>

<style>
	.smaller-column {
		width: 5%;
	}

	.v-data-table /deep/ thead tr th {
		background-color: red !important;
	}

	.v-data-table table thead tr th {
		font-size: 15px;
	}

</style>

